export default {
    state: {
        loading: true,
        statusOk: null,
        errMessage: "",
        okMessage: "",
        post: null,
        markingAsSold: false,
        markingAsSelling: false,
        deleting: false,
        errorModalText: ""
    },
    mutations: {
        'POST_DETAIL_LOADING' (state, val) {
            state.loading = val;
        },
        'POST_DETAIL_LOADING_SUCCESS' (state, val) {
            state.statusOk = true;
            state.post = val;
            state.errMessage = "";
        },
        'POST_DETAIL_LOADING_ERROR' (state, val) {
            state.statusOk = false;
            state.errMessage = val;
        },
        'POST_DETAIL_MARKING_AS_SELLING' (state, val) {
            state.markingAsSelling = val;
        },
        'POST_DETAIL_MARKING_AS_SOLD' (state, val) {
            state.markingAsSold = val;
        },
        'POST_DETAIL_DELETING' (state, val) {
            state.deleting = val;
        },
        'POST_DETAIL_ERROR_MODAL' (state, val) {
            state.errorModalText = val;
        }
    },
    actions: {
        'POST_DETAIL_FETCH' ({commit, rootState}, itemID) {
            /* eslint-disable */
            commit('POST_DETAIL_LOADING', true);
            axios.get(`/item/${itemID}`)
            .then(resp => {
                commit('POST_DETAIL_LOADING', false);
                commit('POST_DETAIL_LOADING_SUCCESS', resp.data.response);
                console.log("detail post", resp);
            })
            .catch(err => {
                commit('POST_DETAIL_LOADING', false);
                if(rootState.locale === "en") commit('POST_DETAIL_LOADING_ERROR', err.response.status === 404 ? 'Post is either deleted or do not exists.':'Error. Server error');
                else commit('POST_DETAIL_LOADING_ERROR', err.response.status === 404 ? 'Ilmoitus on poistettu tai sitä ei ole.':'Error. Server error');
                console.log("detial post err", err);
                /*
                commit('POST_DETAIL_LOADING', false);
                commit('POST_DETAIL_LOADING_SUCCESS', {
                    name: `28" Tuntturi bike`,
                    description: `This is a description of this bike for some reason. It might be long or short for is only for testing lols. I dont know what is this actually.`,
                    frameSize: `28"`,
                    gears: 3,
                    type: `Bike`,
                    maker: `Tuntturi`,
                    subType: `Sports`,
                    currentPrice: 100,
                    oldPrice: 150,
                    imageURIs: ["https://www.99bikes.com.au/media/catalog/product/cache/image/700x560/e9c3970ab036de70892d86c6d221abfe/u/p/uptown-blue_1.jpg", "https://www.99bikes.com.au/media/catalog/product/cache/image/700x560/e9c3970ab036de70892d86c6d221abfe/u/p/uptown-blue_1.jpg", "http://www.wigglestatic.com/product-media/100375136/Brand-X-Road-Bike-Road-Bikes-Black-2017-BRNDXROADXL-0.jpg?w=960&h=430&a=7"],
                    videoURIs: ["http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4", "http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4", "http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4", "http://clips.vorwaerts-gmbh.de/VfE_html5.mp4","http://clips.vorwaerts-gmbh.de/VfE_html5.mp4", "http://clips.vorwaerts-gmbh.de/VfE_html5.mp4"],
                    country: "Finland",
                    province: "Pohjois-pohjanmaa",
                    city: "Oulu",
                    user: {
                        name: "Prataksha Gurung",
                        role: "store",
                        website: "http://google.com",
                        email: "testuser@gmail.com",
                        phone: "+358 456059077",
                        address: "Puistokatu 26 B 21",
                        contacts: [
                            {
                                phone: "+358 456059077",
                                name: "Prataksha Gurung",
                                email: "testuser@gmail.com",
                                languages: ["en", "fi"]
                            },
                            {
                                phone: "+358 456059077",
                                name: "Prataksha Gurung",
                                email: "testuser@gmail.com",
                                languages: ["fi"]
                            }
                        ]
                    },
                    material: "Aluminium",
                    breakType: "Padel break",
                    suspensionType: "None",
                    gender: "M",
                    numOfWheels: 2,
                    wheelSize: `12"`,
                    color: "Red",
                    createdAt: new Date().toISOString()
                });
                */
            });
        },
        'POST_DETAIL_MARK_AS_SOLD' ({commit, dispatch, rootState}, itemID) {
            return new Promise((_, reject) => {
                commit('POST_DETAIL_MARKING_AS_SOLD', true);
                axios.put(`/item/${itemID}`, {status: 'sold'})
                .then(resp => {
                    commit('POST_DETAIL_MARKING_AS_SOLD', false);
                    dispatch('POST_DETAIL_FETCH', itemID);
                    console.log("mark sold post", resp);
                })
                .catch(err => {
                    commit('POST_DETAIL_MARKING_AS_SOLD', false);
                    commit('POST_DETAIL_ERROR_MODAL', rootState.locale === "en" ? 'Server error. Failed to mark post as sold.':'Server error. Ei voitu merkitä myydyksi.');
                    console.log("mark post sold err", err.response);
                    reject();
                });
            });
        },
        'POST_DETAIL_MARK_AS_SELLING' ({commit, dispatch, rootState}, itemID) {
            return new Promise((_, reject) => {
                commit('POST_DETAIL_MARKING_AS_SELLING', true);
                axios.put(`/item/${itemID}`, {status: 'selling'})
                .then(resp => {
                    commit('POST_DETAIL_MARKING_AS_SELLING', false);
                    dispatch('POST_DETAIL_FETCH', itemID);
                    console.log("mark sold post", resp);
                })
                .catch(err => {
                    commit('POST_DETAIL_MARKING_AS_SELLING', false);
                    commit('POST_DETAIL_ERROR_MODAL', rootState.locale === "en" ? 'Server error. Failed to mark post as selling.':'Server error. Ei voitu merkitä myytäväksi.');
                    console.log("mark post sold err", err.response);
                    reject();
                });
            });
        },
        'POST_DETAIL_DELETE' ({commit, dispatch, rootState}, itemID) {
            return new Promise((_, reject) => {
                commit('POST_DETAIL_DELETING', true);
                axios.delete(`/item/${itemID}`)
                .then(resp => {
                    commit('POST_DETAIL_DELETING', false);
                    dispatch('POST_DETAIL_FETCH', itemID);
                    console.log("delete post", resp);
                })
                .catch(err => {
                    commit('POST_DETAIL_DELETING', false);
                    commit('POST_DETAIL_ERROR_MODAL', rootState.locale === "en" ? 'Server error. Failed to delete the post.':'Server error. Ilmoituksen poisto epäonnistui.');
                    console.log("delete post err", err.response);
                    reject();
                });
            });
        }
    }
};